import { useEffect, useRef } from "react";
const usePrevious = (value)=>{
    const ref = useRef(void 0);
    useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
export { usePrevious };
